<template>
  <div>
    <div
      class="mdgridviewpage-bg mainWrap-bg applicationListPage indicatorPage"
    >
      <!-- <HeaderNew></HeaderNew> -->
      <div class="container-fluid maindivWrap pt-4">
        <div class="row">
          <div class="col-12">
            <div class="row mx-0">
              <!-- <div
                class="px-0"
                :class="[
                  allAppsList.length === 0
                    ? 'col-sm-6 offset-sm-6'
                    : 'col-sm-8 offset-sm-4'
                ]"
              > -->
              <div class="col-12 px-0">
                <div class="row mx-0">
                  <div class="col-4 px-0">
                    <form>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fa fa-search" aria-hidden="true"></i>
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Search..."
                          id
                          name
                          v-model="searchOrgGroupName"
                          style="border-left: 0"
                        />
                      </div>
                    </form>
                  </div>
                  <div class="col-8 px-0">
                    <div class="d-flex" style="justify-content: flex-end">
                      <div class="mx-2">
                        <form class="form-inline" action="/action_page.php">
                          <label for="" class="mr-sm-2">Show:</label>
                          <select
                            class="form-control"
                            id="sel1"
                            v-model="perPage"
                          >
                            <option>10</option>
                            <option>50</option>
                            <option>100</option>
                            <option>500</option>
                          </select>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <nav class="navbar navbar-expand-sm bg-light px-0 d-none">
                  <!-- Links -->
                  <ul class="navbar-nav justify-content-end w-100">
                    <li class="nav-item">
                      <a class="nav-link" href="#">
                        <form>
                          <div class="input-group mb-3">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <i class="fa fa-search" aria-hidden="true"></i>
                              </span>
                            </div>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Search..."
                              id
                              name
                              v-model="searchOrgGroupName"
                              style="border-left: 0"
                            />
                          </div>
                        </form>
                      </a>
                    </li>
                    <!-- <li class="nav-item">
                      <a class="nav-link" href="#">
                        <div class="btn btn-light btn-sm" type="button">
                          <i class="fa fa-th-large" aria-hidden="true"></i>
                        </div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#">
                        <div class="btn btn-light btn-sm" type="button">
                          <i class="fa fa-bars" aria-hidden="true"></i>
                        </div>
                      </a>
                    </li> -->
                    <li class="nav-item">
                      <a class="nav-link" href="#">
                        <form class="form-inline" action="/action_page.php">
                          <label for="" class="mr-sm-2">Show:</label>
                          <select
                            class="form-control"
                            id="sel1"
                            v-model="perPage"
                          >
                            <option>10</option>
                            <option>50</option>
                            <option>100</option>
                            <option>500</option>
                          </select>
                        </form>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="listingTable mb-4">
              <div class="row mx-0">
                <div class="col-12 px-0">
                  <div class="row">
                    <div class="col-6">
                      <h5 class="section_title mt-3">Location Group</h5>
                    </div>
                    <div class="col-6">
                      <a
                        href="javascript:void(0)"
                        class="btn btn-sm float-right addTemp_btn mt-3 mr-0"
                        @click="showForm()"
                      >
                        <span class="border_bottom_grey">
                          <i class="fa fa-plus" aria-hidden="true"></i> Add
                          Location Group
                        </span>
                      </a>
                    </div>
                  </div>
                  <div class="card tableCard">
                    <div class="card-body px-0 pt-2">
                      <table
                        class="table table-striped table-hover mb-0 bg-white"
                        style="
                          border-radius: 10px;
                          box-shadow: 0px 0px 2px #ddd;
                        "
                      >
                        <thead>
                          <tr
                            class="row mx-0"
                            style="border-radius: 10px 10px 0 0"
                          >
                            <th class="col-1" style="border-top: 0">No.</th>
                            <th class="col-6" style="border-top: 0">
                              Location Group Name
                            </th>

                            <th class="col-3" style="border-top: 0">
                              Updated On
                            </th>
                            <th class="col-2" style="border-top: 0">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(indicator, ind) in allIndList1">
                            <tr class="row mx-0" :key="ind">
                              <td class="col-1">{{ ind + 1 }}.</td>
                              <td class="col-6">{{ indicator.displayName }}</td>

                              <td class="col-3">{{ indicator.lastUpdated }}</td>
                              <td class="col-2">
                                <div class="iconGroup">
                                  <a href="#organisationGroup">
                                    <i
                                      class="fa fa-pencil-square-o cursor-pointer"
                                      aria-hidden="true"
                                      v-b-tooltip.hover
                                      title="Edit"
                                      @click="editGroup(indicator.id)"
                                    ></i>
                                  </a>

                                  <i
                                    class="fa fa-trash cursor-pointer"
                                    aria-hidden="true"
                                    v-b-tooltip.hover
                                    title="Delete"
                                    @click="deleteGroup(indicator.id)"
                                  ></i>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="mt-3" v-if="allIndList1.length > 0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="allIndLen"
                      :per-page="perPage"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"
                      align="center"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12" v-if="showIndForm" ref="organisationGroup">
            <div class="wizardCard mb-4">
              <div class="card shadow-sm">
                <div class="card-header">Add Location Group</div>
                <div class="card-body">
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorName"
                          class="col-sm-3 col-form-label"
                          >Location Group Name</label
                        >
                        <div class="col-sm-9">
                          <input
                            type="text"
                            class="form-control"
                            id="indicatorName"
                            placeholder
                            v-model="orgGroupName"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorTypeName"
                          class="col-sm-3 col-form-label"
                          >Location Units</label
                        >
                        <div class="col-sm-9" v-if="options">
                          <treeselect
                            class="organisationTreeList"
                            :show-count="true"
                            :options="options"
                            v-model="value"
                            :multiple="true"
                            placeholder="Search..."
                            :default-expand-level="defaultExpandLevel"
                          />
                          <small style="color: #fb0a37"
                            >{{ value.length }} Location units selected</small
                          >
                          <!-- <treeselect class="form-control" :options="options" :show-count="true" :multiple="true" placeholder="Search.." v-model="value" :flat="false" :default-expand-level="defaultExpandLevel"/> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="bottomSubmitbtn float-right mb-4">
              <button class="btn btn-newprimary" @click="resetForm">
                Cancel
                <!-- <i
                  class="fa fa-angle-double-right pl-2 text-white"
                  aria-hidden="true"
                ></i> -->
              </button>
              <button
                class="btn btn-newprimary"
                @click="updateOrgGroups"
                v-if="groupId"
              >
                Update
                <!-- <i
                  class="fa fa-angle-double-right pl-2 text-white"
                  aria-hidden="true"
                ></i> -->
              </button>
              <button class="btn btn-newprimary" @click="saveOrgGroups" v-else>
                Save
                <!-- <i
                  class="fa fa-angle-double-right pl-2 text-white"
                  aria-hidden="true"
                ></i> -->
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <training-footer></training-footer> -->
  </div>
</template>
<script>
import HeaderNew from "../components/layout/HeaderNew";
import trainingFooter from "../components/trainingFooter";
import ApiServices from "../service/ApiServices";
import swal from "sweetalert2";
import moment from "moment";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
window.Swal = swal;

export default {
  components: {
    HeaderNew,
    trainingFooter,
    Treeselect,
  },
  data() {
    return {
      searchOrgGroupName: "",
      organisationGroups: null,
      updatetableorgGroup: false,
      orgGroupName: "",
      levelID: null,
      locationID: null,
      options: [],
      value: [],
      defaultExpandLevel: 1,
      groupId: "",
      showIndForm: false,
      allOrgList: [],
      perPage: 10,
      currentPage: 1,
    };
  },
  computed: {
    indicatorTypeList: function () {
      let typeArr = this.indicatorTypes;

      var arr = [];
      var obj = { value: "", text: "Select Indicator Type" };
      arr.push(obj);
      typeArr.forEach((type, ind) => {
        var obj = { value: "", text: "" };
        obj.value = type.id;
        obj.text = type.displayName;
        arr.push(obj);
      });
      // console.log(arr);
      return arr;
    },
    allIndList1() {
      let filteredInd = this.allOrgList.filter(
        (a) =>
          (a.displayName &&
            a.displayName
              .toLowerCase()
              .includes(this.searchOrgGroupName.toLowerCase())) ||
          // (a.createdBy &&
          //   a.createdBy
          //     .toLowerCase()
          //     .includes(this.searchName.toLowerCase())) ||
          (a.lastUpdated &&
            a.lastUpdated
              .toLowerCase()
              .includes(this.searchOrgGroupName.toLowerCase()))
      );
      this.allIndLen = filteredInd.length;
      // console.log(filteredInd);
      return filteredInd.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    rows() {
      return this.allAppsList.length;
    },
  },
  watch: {},
  methods: {
    resetForm() {
      this.showIndForm = false;
      this.orgGroupName = "";
      this.value = [];
    },
    showForm() {
      this.showIndForm = true;
      this.orgGroupName = "";
      this.value = [];
      this.$nextTick(() => {
        this.goTo('organisationGroup')
      })
    },
    goTo(refName) {
      let element = this.$refs[refName];
      console.log(element)
      if(element) {
        let top = element.offsetTop;
        console.log(top)

        window.scrollTo(0, top);
      }
    },
    editGroup(id) {
      this.showIndForm = true;
      this.updatetableorgGroup = true;
      this.groupId = id;
      ApiServices.getIndOrganisationGroup(id).then((response) => {
        let values = [];
        this.orgGroupName = response.data.displayName;
        response.data.organisationUnits.forEach((v) => {
          values.push(v.id);
        });
        this.value = values;
      });
    },
    deleteGroup(id) {
      this.$swal({
        title: "Delete this Group?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.$root.loading = true;
          ApiServices.deleteOrganisationGroup(id).then((res) => {
            if (res.data.status === "OK") {
              //console.log(response.data)
              this.$swal({
                title: "Group deleted successfully",
                type: "success",
              });
              this.getOrganisationList();
              this.$root.loading = false;
            } else {
              this.$swal({
                title: this.$i18n.t("adminPage.error"),
                text: `${response.data.message}`,
                type: "error",
              });
              return;
            }
          });
        }
      });
    },
    saveOrgGroups() {
      //console.log(this.value)
      this.$root.loading = true;
      let locId = [];
      this.value.forEach((loc) => {
        locId.push({ id: loc });
      });
      let orgData = { name: this.orgGroupName, organisationUnits: locId };
      ApiServices.addOrganisationGroup(orgData).then((response) => {
        this.getOrganisationList();
        this.$swal({
          title: "Group created successfully",
          type: "success",
        });
        (this.value = []), (this.orgGroupName = "");
        this.showIndForm = false;
        this.$root.loading = false;
      });
    },
    updateOrgGroups() {
      this.$root.loading = true;
      let locId = [];
      this.value.forEach((loc) => {
        locId.push({ id: loc });
      });
      let orgData = { name: this.orgGroupName, organisationUnits: locId };
      ApiServices.updateOrganisationGroup(this.groupId, orgData).then(
        (response) => {
          this.getOrganisationList();
          this.$swal({
            title: "Group updated successfully",
            type: "success",
          });
          (this.value = []), (this.orgGroupName = ""), (this.groupId = "");
          this.showIndForm = false;
          this.$root.loading = false;
        }
      );
    },

    gotoApp(appId, appUserId) {
      window.open(
        `http://localhost:8080/#/?appId=${appId}&appUserId=${appUserId}`,
        "_blank"
      );
    },
    logout() {
      //dhis-web-commons-security/logout.action
      localStorage.removeItem("userProfile");
      localStorage.removeItem("loggedInUserId");
      ApiServices.RestGetCall(
        "dhis-web-commons-security/logout.action",
        {}
      ).then((res) => {
        console.log(res);
      });
      //window.open('http://intraavenir.duredemos.com/service/dhis-web-commons-security/logout.action', '_blank');
      this.$router.push("/");
    },

    getConfigAccess() {
      this.$root.loading = true;
      // ApiServices.getAllKeys().then(async (response) => {
      //   response.data.forEach((a) => {
      //     let keyName = a.split("_");
      //     if (a.includes("applicationModule") && keyName.includes("en")) {
      //       ApiServices.getSavedConfig(a).then((appres) => {
      //         let levelID = appres.data.defaultLevelID,
      //           locationID = appres.data.defaultLocationID[0];
      //
      //         this.getLocationList(levelID, locationID);
      //         this.levelID = levelID;
      //         this.locationID = locationID;
      //         this.$root.loading = false;
      //       });
      //     }
      //   });
      // });
      let appId = sessionStorage.getItem('appId'), appUserId = sessionStorage.getItem('appUserId')
      ApiServices.getSavedConfig(`${appUserId}_${appId}_applicationModule_en`).then(appres => {
        // console.log("appres", appres)
        let levelID = appres.data.defaultLevelID, locationID = appres.data.defaultLocationID[0];

        this.getLocationList(levelID, locationID);
        this.levelID = levelID;
        this.locationID = locationID;
        this.$root.loading = false;
      }).catch(() => this.$root.loading = false)
    },
    getLocationList(defaultLevelID, defaultLocationID) {
      ApiServices.getOrganisationChildren(
        defaultLocationID,
        defaultLevelID
      ).then((loc) => {
        const renamedObj = this.renameKeys(loc.data);
        renamedObj.children.sort((a, b) => a.label.localeCompare(b.label));
        renamedObj.children.forEach((c) => {
          c.children.sort((a, b) => a.label.localeCompare(b.label));
        });
        // console.log("renamedObj", renamedObj);
        this.options = [renamedObj];
        //console.log(this.locationID)
        this.value = [this.locationID];
      });
    },
    renameKeys(obj) {
      const keyValues = Object.keys(obj).map((key) => {
        let newKey = null,
          level = null,
          id = null;

        if (key === "displayName") {
          newKey = "label";
        } else {
          newKey = key;
        }
        if (key === "children") {
          obj[key] = obj[key].map((obj) => this.renameKeys(obj));
        }
        return {
          [newKey]: key === "id" ? obj.id : obj[key],
        };
      });
      return Object.assign({}, ...keyValues);
    },
    getOrganisationList() {
      ApiServices.RestGetCall(
        "api/organisationUnitGroups.json?filter=name:ne:default&fields=displayName%2CshortName%2Cid%2ClastUpdated%2Ccreated%2CdisplayDescription%2Ccode%2CpublicAccess%2Caccess%2Chref%2Clevel%2CdisplayName%2CpublicAccess%2ClastUpdated%2C&order=displayName%3AASC"
      ).then((response) => {
        // console.log(response);
        this.allOrgList = response.organisationUnitGroups;
      });
    },
  },
  mounted() {
    this.userProfile = JSON.parse(localStorage.getItem("userProfile"));
    this.baseUrl = ApiServices.getBaseUrl();
    this.dashboardUrl = this.baseUrl + this.dashboardUrl;
    this.getConfigAccess();
    this.getOrganisationList();
  },
};
</script>
<style scoped lang="scss">
.mainWrap-bg {
  background-color: #f4f4f4 !important;
  background-image: none;
  /* background-size: cover;
  background-position: center; */
  min-height: 100vh;
  /* padding: 20px 40px; */
  padding: 10px 20px;
}
.maindivWrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.form-control {
  background-color: transparent !important;
}
.tableCard {
  .table {
    thead {
      tr {
        background: #2e3f53;
        th {
          color: #fff;
        }
      }
    }
  }
}
.addIndicatorTypebtn {
  position: relative;
  text-align: left;
  font-weight: 200 !important;
  border-radius: 2px !important;
  font-size: 0.875rem;
}
.addIndicatorTypebtn:hover {
  position: relative;
  text-align: left;
  font-weight: 200 !important;
  border-radius: 2px !important;
  font-size: 0.875rem;
}
.addIndicatorTypebtn::after {
  position: absolute;
  right: 15px;
  top: 15px;
}
.multiSelectOption option {
  font-size: 0.75rem;
  background: #f5f5f5;
  padding: 10px 12px;
  margin-bottom: 1%;
  white-space: initial;
  min-height: 2.5em;
  font-family: "Montserrat-Regular";
}
.swipTextWrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.checkValid {
  text-align: left;
  width: 100%;
  position: relative;
  bottom: -57px;
  font-weight: 600;
}
textarea {
  width: 100%;
  height: 200px !important;
}
.has-search .form-control {
  padding-left: 2.375rem;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  // height: 2.375rem;
  // line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
}
table tbody {
  border-radius: 0px 0px 10px 10px;
}
table tbody tr:last-child td:nth-last-child(1) {
  border-radius: 0px 0px 10px 0px;
}
table tbody tr:last-child td:nth-last-child(4) {
  border-radius: 0px 0px 0px 10px;
}
</style>
